













import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import * as services from "@/services/analyses";
import AreaExpansionChart from "./AreaExpansionChart.vue";
import { Analysis } from "@/api/analyses/types";

@Component({
  name: "AreaExpansionChartController",
  components: {
    AreaExpansionChart,
  },
})
export default class AreaExpansionChartController extends Vue {

  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: String, required: true })
  private harvestSeason!: string;

  @Prop({ type: String, required: true })
  private cropType!: string;

  private loaded = false;

  private async mounted() {
    await this.loadChart();
    this.loaded = true;
  }

  private async loadChart() {
    this.$emit('update:loading', true);
    try {
      await services.findAreaExpansionByHarvestSeasonAndCropType(
        this.analysis.uuid,
        this.harvestSeason,
        this.cropType
      );
    } finally {
      this.$emit('update:loading', false);
    }
  }

  get fetchKey() {
    return `${this.harvestSeason}:${this.cropType}:${this.analysis?.uuid}`;
  }

  @Watch('fetchKey')
  private async onFetchKeyChange() {
    await this.loadChart();
  }

  get getAreaExpansionList() {
    return this.$store.state.analyses.areaExpansionContext;
  }
}
